import { render } from "./App.vue?vue&type=template&id=537b1038&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=537b1038&lang=stylus"
import "./App.vue?vue&type=style&index=1&id=537b1038&lang=stylus"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__